// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"po-z","breadcrumbForward":"qo-z","breadcrumbBack":"ro-z","selected":"so-z"};